import React from 'react'
import { Text } from 'native-base'
import type { StyleProp, TextStyle } from 'react-native'

const Subtitle: React.FC<{
  style?: StyleProp<TextStyle>;
  testID?: string;
}> = ({ children, style, testID }) => {
  return (
    <Text
      testID={testID}
      fontSize="xs"
      fontWeight={800}
      fontFamily="Lato"
      color="dark"
      style={style}
    >
      {children}
    </Text>
  )
}

export default Subtitle
